// components/CookieConsent/CookieConsent.tsx
'use client'

import React from 'react'

import { SeericButton } from '@/app/components/SeericButton/SeericButton'
import { Cookie, Shield, X } from 'lucide-react'
import './CookieConsent.css'
import { useCookieConsent } from '@/hooks/animation/useCookieConsent'

export const CookieConsent: React.FC = () => {
  const { consentStatus, acceptCookies, refuseCookies, needsConsent } = useCookieConsent()

  if (!needsConsent) {
    return null
  }

  const isReturnUser = consentStatus === 'refused_previously'

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-modal">
        <div className="cookie-consent-header">
          <div className="cookie-consent-icon">
            <Cookie size={24} />
          </div>
          <h2 className="cookie-consent-title">
            {isReturnUser ? 'Cookies requis' : 'Gestion des cookies'}
          </h2>
        </div>

        <div className="cookie-consent-content">
          <div className="cookie-consent-text">
            {isReturnUser ? (
              <p>
                Vous avez précédemment indiqué que vous refusiez les cookies de notre site. 
                Afin d'accéder aux fonctionnalités de notre site, vous devez accepter nos cookies, 
                en pressant le bouton « Accepter » ci-dessous.
              </p>
            ) : (
              <p>
                Nous utilisons des cookies pour vous fournir les fonctionnalités essentielles 
                telles que la sécurité et la gestion de vos sessions. Ces cookies ne sont jamais 
                transmis à d'autres tiers et ne font l'objet d'aucun traitement statistique. 
                Le refus des cookies de notre site vous empêchera d'utiliser les fonctionnalités proposées.
              </p>
            )}
          </div>

          <div className="cookie-consent-features">
            <div className="cookie-feature">
              <Shield size={16} />
              <span>Sécurité et authentification</span>
            </div>
            <div className="cookie-feature">
              <Cookie size={16} />
              <span>Gestion des sessions</span>
            </div>
          </div>
        </div>

        <div className="cookie-consent-actions">
          <SeericButton
            variant="modal-primary"
            onClick={acceptCookies}
            className="cookie-accept-btn"
          >
            Accepter
          </SeericButton>
          
          {!isReturnUser && (
            <SeericButton
              variant="modal-secondary"
              onClick={refuseCookies}
              className="cookie-refuse-btn"
            >
              Refuser
            </SeericButton>
          )}
        </div>
      </div>
    </div>
  )
}